/* eslint-disable @typescript-eslint/no-explicit-any */
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { workSpaceType, broadTagFilterList , tagListType} from './types';
import { Dataset } from 'store/home/types';
import { addNewAnalougePlot, getGridColumnsDataThunk, getAllAnalogueSettingTagsThunk, getResultTagListThunk, getAllAnaloguePlotListThunk, getBroadFilterParameterThunk, addBroadFilterParameterThunk, deleteBroadFilterParameterThunk, resetBroadFilterParameterThunk } from './thunk';

interface AnalougeState {
  subDataSet: Dataset,
  analoguePlotList: workSpaceType [],  
  isLoading: boolean,
  error: string | null,
  workSpaceIndex: number,
  broadFilterTagList: broadTagFilterList [],
  analogueData: any,
  tagList: tagListType[],
  selectedTemplate:string,
  resultTagAttributeList: any[],
  mapData: any[],
  analogueParameterList: any[],
  filterMode: string,
  storageRecords: number,
  dataRefreshTrigger: number,
  selectedResultItems: string[], // Array of IdentifierFieldIds
  plotAxisX: { axisName: string; tagAttributeId: string } | null,
  plotAxisY: { axisName: string; tagAttributeId: string } | null,
}

const initialState: AnalougeState = {
  subDataSet: {
    id: '',
    identifierFieldType: 0,
    identifierFieldUnit: 0,
    title: '',
    createdBy: {
        name: '',
        id: '',
    },
    sharedBy: [],
    description: '',
    isOwner: false,
  },
  analoguePlotList: [],
  isLoading: false,
  error: null,
  workSpaceIndex: 0,
  broadFilterTagList: [],
  analogueData: null,
  tagList: [],
  selectedTemplate:'240e50fa-d600-45b0-b1b6-1aa1f6463759',
  resultTagAttributeList: [],
  analogueParameterList: [],
  mapData: [],
  filterMode: 'explore',
  storageRecords: 0,
  dataRefreshTrigger: 0,
  selectedResultItems: [],
  plotAxisX: null,
  plotAxisY: null,
};

export const analogueSlice = createSlice({
  name: 'analogue',
  initialState,
  reducers: {
    setSubDataSet: (state, action) => {
      state.subDataSet = action.payload;
    },
    setWorkSpaceIndex: (state, action) => {
      state.workSpaceIndex = action.payload;
    },
    setAnalogueData: (state, action) => {
      state.analogueData = action.payload;
    },
    setSelectedTemplate: (state, action) => {
      state.selectedTemplate = action.payload;
    },
    setMapData: (state, action) => {
      state.mapData = action.payload;
    },
    setFilterMode:(state, action) => {
      state.filterMode = action.payload.value;
    },
    setStorageRecord:(state, action) => {
      state.storageRecords = action.payload;
    },
    setDataRefreshTrigger: (state, action: PayloadAction<number>) => {
      state.dataRefreshTrigger = action.payload;
    },
    setSelectedResultItems: (state, action: PayloadAction<string[]>) => {
      state.selectedResultItems = action.payload;
    },
    setPlotAxis: (state, action: PayloadAction<{ axisType: string; axisName: string; tagAttributeId: string }>) => {
      const { axisType, axisName, tagAttributeId } = action.payload;
      if (axisType === 'xAxis') {
        state.plotAxisX = { axisName, tagAttributeId };
      } else if (axisType === 'yAxis') {
        state.plotAxisY = { axisName, tagAttributeId };
      }
    },
  },
  extraReducers: {
    [addNewAnalougePlot.pending.type]: (state) => {
      state.isLoading = true;
    },

    [addNewAnalougePlot.fulfilled.type]: (state) => {
      state.error = null;
      state.isLoading = false;
    },

    [addNewAnalougePlot.rejected.type]: (state, action: PayloadAction<string>) => {
      state.isLoading = false;
      state.error = action.payload;
    },


    [getAllAnaloguePlotListThunk.pending.type]: (state) => {
      state.isLoading = true;
    },

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    [getAllAnaloguePlotListThunk.fulfilled.type]: (state, action: PayloadAction<any>) => {
      state.analoguePlotList = action.payload
      state.error = null;
      state.isLoading = false;
    },

    [getAllAnaloguePlotListThunk.rejected.type]: (state, action: PayloadAction<string>) => {
      state.isLoading = false;
      state.error = action.payload;
    },

    [getBroadFilterParameterThunk.pending.type]: (state) => {
      state.isLoading = true;
    },

    [getBroadFilterParameterThunk.fulfilled.type]: (state, action) => {
      state.broadFilterTagList = action.payload;
      state.error = null;
      state.isLoading = false;
    },

    [getBroadFilterParameterThunk.rejected.type]: (state, action: PayloadAction<string>) => {
      state.isLoading = false;
      state.error = action.payload;
    },

    [addBroadFilterParameterThunk.pending.type]: (state) => {
      state.isLoading = true;
    },

    [addBroadFilterParameterThunk.fulfilled.type]: (state, action) => {
      state.broadFilterTagList = action.payload
      state.error = null;
      state.isLoading = false;
    },

    [addBroadFilterParameterThunk.rejected.type]: (state, action: PayloadAction<string>) => {
      state.isLoading = false;
      state.error = action.payload;
    },

    [deleteBroadFilterParameterThunk.pending.type]: (state) => {
      state.isLoading = true;
    },

    [deleteBroadFilterParameterThunk.fulfilled.type]: (state, action) => {
      state.broadFilterTagList = action.payload
      state.error = null;
      state.isLoading = false;
    },

    [deleteBroadFilterParameterThunk.rejected.type]: (state, action: PayloadAction<string>) => {
      state.isLoading = false;
      state.error = action.payload;
    },

    [resetBroadFilterParameterThunk.pending.type]: (state) => {
      state.isLoading = true;
    },

    [resetBroadFilterParameterThunk.fulfilled.type]: (state, action) => {
      state.broadFilterTagList = action.payload
      state.error = null;
      state.isLoading = false;
    },

    [resetBroadFilterParameterThunk.rejected.type]: (state, action: PayloadAction<string>) => {
      state.isLoading = false;
      state.error = action.payload;
    },

    [getResultTagListThunk.pending.type]: (state) => {
      state.isLoading = true;
    },

    [getResultTagListThunk.fulfilled.type]: (state, action) => {
      state.tagList = action.payload
      state.error = null;
      state.isLoading = false;
    },

    [getResultTagListThunk.rejected.type]: (state, action: PayloadAction<string>) => {
      state.isLoading = false;
      state.error = action.payload;
    },

    [getGridColumnsDataThunk.pending.type]: (state) => {
      state.isLoading = true;
    },

    [getGridColumnsDataThunk.fulfilled.type]: (state, action) => {
      state.resultTagAttributeList = action.payload
      state.error = null;
      state.isLoading = false;
    },

    [getGridColumnsDataThunk.rejected.type]: (state, action: PayloadAction<string>) => {
      state.isLoading = false;
      state.error = action.payload;
    },

    [getAllAnalogueSettingTagsThunk.pending.type]: (state) => {
      state.isLoading = true;
    },

    [getAllAnalogueSettingTagsThunk.fulfilled.type]: (state, action) => {
      state.analogueParameterList = action.payload
      state.error = null;
      state.isLoading = false;
    },

    [getAllAnalogueSettingTagsThunk.rejected.type]: (state, action: PayloadAction<string>) => {
      state.isLoading = false;
      state.error = action.payload;
    },

    
  },
})

export default analogueSlice.reducer